import { createRoot } from 'react-dom/client';
import App from './app/app.tsx';
import './styles/style.css';

const isElectron = () => window && window.electron;
const isDevMode = import.meta.env.VITE_DEV_MODE === 'true';

if (!isElectron() && !isDevMode) {
  window.location.href = 'about:blank';
} else {
  createRoot(document.getElementById('root')!).render(<App />);
}
